import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ActionsFormatter from './ActionsFormatter';

const ProductColumns = ({ handleClickUpdate }) => {
    const { t } = useTranslation();

    const nameColumn = {
        align: 'left',
        display: 'flex',
        editable: true,
        field: 'name',
        headerName: t('Name'),
        minWidth: 300,
        renderCell: (params) => {
            const { row } = params;
            return (
                <Typography variant="caption" fontWeight="bold">
                    {row.name}
                </Typography>
            );
        },
    };

    const actionsColumn = {
        align: 'left',
        display: 'flex',
        field: '',
        flex: 1,
        renderCell: (params) => {
            const { row } = params;
            return (
                <ActionsFormatter
                    handleClickUpdate={handleClickUpdate}
                    row={row}
                />
            );
        },
        sortable: false,
    };

    return [nameColumn, actionsColumn];
};

ProductColumns.propTypes = {
    canDelete: PropTypes.bool,
    canUpdate: PropTypes.bool,
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleClickDelete: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    rowModesModel: PropTypes.object,
    selectedRowId: PropTypes.func,
    setRowModesModel: PropTypes.func,
    setSelectedRowId: PropTypes.func,
};

export default ProductColumns;
